// extracted by mini-css-extract-plugin
export var eventsWrapper = "EventsWrapper-module--eventsWrapper--CCvQE";
export var eventsTimeline = "EventsWrapper-module--eventsTimeline--3yzkU";
export var cards = "EventsWrapper-module--cards--1D0uC";